import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18nModule } from '@nx-ng/i18n';
import { MaterialModule } from '@nx-ng/material';
import { MdRendererModule } from '@nx-ng/md-renderer';

import { ActionButtonComponent } from './components/action-button/action-button.component';
import { AddressTestComponent } from './components/address/address-test.component';
import { AddressComponent } from './components/address/address.component';
import { BasketAddItemComponent } from './components/basket-add-item/basket-add-item.component';
import { BasketItemComponent } from './components/basket-item/basket-item.component';
import { BasketDiscountVoucherComponent } from './components/basket-discount-voucher/basket-discount-voucher.component';
import { SummaryTotalsComponent } from './components/summary-totals/summary-totals.component';
import { BasketItemQuantityComponent } from './components/basket-item-quantity/basket-item-quantity.component';
import { BasketSubscribeSaveBannerComponent } from './components/basket-subscribe-save-banner/basket-subscribe-save-banner.component';
import { BasketComponent } from './components/basket/basket.component';
import { BillingAddressComponent } from './components/billing-address/billing-address.component';
import { BookingSummaryTicketComponent } from './components/booking-summary-ticket/booking-summary-ticket.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { BuySingleButtonComponent } from './components/buy-single-button/buy-single-button.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { CurrentPageIndicatorComponent } from './components/current-page-indicator/current-page-indicator.component';
import { DatepickerMonthYearComponent } from './components/datepicker-month-year/datepicker-month-year.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { EmptyBasketComponent } from './components/empty-basket/empty-basket.component';
import { IconHeaderComponent } from './components/icon-header/icon-header.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LocalRadioGroupComponent } from './components/local-radio-group/local-radio-group.component';
import { LoggedInComponent } from './components/logged-in/logged-in.component';
import { MobilePhoneComponent } from './components/mobile-phone/mobile-phone.component';
import {
  BasketModalComponent,
  BasketErrorModalComponent,
  InfoModalComponent,
  MapModalComponent,
  ModalHeaderComponent,
  RewardsModalComponent,
} from './components/modal';
import { NotImplementedComponent } from './components/not-implemented/not-implemented.component';
import { RadioGroupItemComponent } from './components/radio-group-item/radio-group-item.component';
import { SelectComponent } from './components/select-field/select.component';
import { SubmitButtonComponent } from './components/submit-button/submit-button.component';
import { SuccessIndicatorComponent } from './components/success-indicator/success-indicator.component';
import { TextFieldComponent } from './components/text-field/text-field.component';
import { TicketCategoryComponent } from './components/ticket-category/ticket-category.component';
import { TicketDeliveryComponent } from './components/ticket-delivery/ticket-delivery.component';
import { TicketFilterComponent } from './components/ticket-filter/ticket-filter.component';
import { TicketOptionComponent } from './components/ticket-option/ticket-option.component';
import { TicketResultTypeComponent } from './components/ticket-result-type/ticket-result-type.component';
import { ValidationSuccessComponent } from './components/validation-success/validation-success.component';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { MobileValidatorDirective } from './directives/mobile-validator.directive';
import { ParenthesesPipe } from './pipes/Parentheses.pipe';
import { PostcodeComponent } from './components/postcode/postcode.component';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from './components/loader/loader.component';
import { AutofocusDirective } from './directives/autofocus.directive';
import { FocusFirstFormErrorDirective } from './directives/focus-first-form-error.directive';
import { MTicketInfoModalComponent } from './components/modal/info-modal/m-ticket-info-modal/m-ticket-info-modal.component';
import { PaymentSuccessPageComponent } from './components/payment-success-page/payment-success-page.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    I18nModule,
    MaterialModule,
    MdRendererModule,
    RouterModule,
  ],
  declarations: [
    ActionButtonComponent,
    AutofocusDirective,
    AddressComponent,
    AddressTestComponent,
    BasketAddItemComponent,
    BasketComponent,
    BasketItemComponent,
    BasketDiscountVoucherComponent,
    SummaryTotalsComponent,
    BasketItemQuantityComponent,
    BasketModalComponent,
    BasketErrorModalComponent,
    BasketSubscribeSaveBannerComponent,
    BillingAddressComponent,
    BookingSummaryTicketComponent,
    BreadcrumbComponent,
    BuySingleButtonComponent,
    CheckboxComponent,
    ClickOutsideDirective,
    CurrentPageIndicatorComponent,
    DatepickerComponent,
    DatepickerMonthYearComponent,
    EmptyBasketComponent,
    IconHeaderComponent,
    InfoModalComponent,
    LayoutComponent,
    LocalRadioGroupComponent,
    LoggedInComponent,
    MapModalComponent,
    MobilePhoneComponent,
    MobileValidatorDirective,
    ModalHeaderComponent,
    NotImplementedComponent,
    ParenthesesPipe,
    PostcodeComponent,
    RadioGroupItemComponent,
    RewardsModalComponent,
    SelectComponent,
    SubmitButtonComponent,
    SuccessIndicatorComponent,
    TextFieldComponent,
    TicketCategoryComponent,
    TicketDeliveryComponent,
    TicketFilterComponent,
    TicketOptionComponent,
    TicketResultTypeComponent,
    ValidationSuccessComponent,
    LoaderComponent,
    FocusFirstFormErrorDirective,
    MTicketInfoModalComponent,
    PaymentSuccessPageComponent,
  ],
  exports: [
    ActionButtonComponent,
    AutofocusDirective,
    AddressComponent,
    BasketAddItemComponent,
    BasketComponent,
    BasketItemComponent,
    BasketModalComponent,
    BasketErrorModalComponent,
    BasketSubscribeSaveBannerComponent,
    BillingAddressComponent,
    BookingSummaryTicketComponent,
    BreadcrumbComponent,
    BuySingleButtonComponent,
    CheckboxComponent,
    ClickOutsideDirective,
    CurrentPageIndicatorComponent,
    DatepickerComponent,
    DatepickerMonthYearComponent,
    EmptyBasketComponent,
    IconHeaderComponent,
    InfoModalComponent,
    LayoutComponent,
    LocalRadioGroupComponent,
    LoggedInComponent,
    MapModalComponent,
    MobilePhoneComponent,
    MobileValidatorDirective,
    NotImplementedComponent,
    ParenthesesPipe,
    RadioGroupItemComponent,
    RewardsModalComponent,
    SelectComponent,
    SubmitButtonComponent,
    SuccessIndicatorComponent,
    SummaryTotalsComponent,
    TextFieldComponent,
    TicketCategoryComponent,
    TicketDeliveryComponent,
    TicketFilterComponent,
    TicketOptionComponent,
    TicketResultTypeComponent,
    ValidationSuccessComponent,
    LoaderComponent,
    FocusFirstFormErrorDirective,
    MTicketInfoModalComponent,
    PaymentSuccessPageComponent,
  ],
})
export class ComponentsCommonModule {}
